var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShoppingBagIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "icon-shopping-bag"
  }, "Shopping Bag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "icon-shopping-bag"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.16663L2.5 5.49996V17.1666C2.5 17.6087 2.67559 18.0326 2.98816 18.3451C3.30072 18.6577 3.72464 18.8333 4.16667 18.8333H15.8333C16.2754 18.8333 16.6993 18.6577 17.0118 18.3451C17.3244 18.0326 17.5 17.6087 17.5 17.1666V5.49996L15 2.16663H5Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.5H17.5",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 8.83337C13.3334 9.71743 12.9822 10.5653 12.3571 11.1904C11.732 11.8155 10.8841 12.1667 10.0001 12.1667C9.11603 12.1667 8.26818 11.8155 7.64306 11.1904C7.01794 10.5653 6.66675 9.71743 6.66675 8.83337",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShoppingBagIcon);
export default ForwardRef;